module.exports = __webpack_public_path__ + "b4ed0da2f2e246a8a90a795ccee645aa.jpg";